import {
  channelFormCssPath,
  channelFormCancelBtnCssPath,
  channelFormEmailBodyCssPath,
  channelFormEmailChannelCssPath,
  channelFormEmailSubjectCssPath,
  channelFormIdCssPath,
  channelFormNameCssPath,
  channelFormSaveBtnCssPath,
  channelFormSMSCssPath,
  channelFormSMSMessageCssPath,
  channelFormTitleCssPath,
  channelFormTypeCssPath,
} from './cssPaths.js';

onChangeFormChannelType();
function onChangeFormChannelType() {
  $(document).on('change', channelFormTypeCssPath, function () {
    toggleFormChannelType(this.value);
  });
}

function toggleFormChannelType(type) {
  if (type === 'email') {
    $(channelFormEmailChannelCssPath).show();
    $(channelFormSMSCssPath).hide();
  } else if (type === 'sms') {
    $(channelFormEmailChannelCssPath).hide();
    $(channelFormSMSCssPath).show();
  }
}

export function fill({ mode, title, saveBtnText }, channel) {
  $(channelFormCssPath).attr('data-mode', mode); // 'create' or 'edit'
  $(channelFormTitleCssPath).text(title);
  $(channelFormSaveBtnCssPath).text(saveBtnText);
  $(channelFormIdCssPath).val(channel.id || '');
  $(channelFormNameCssPath).val(channel.name || '');
  const channelType = channel.type || 'email';
  $(channelFormTypeCssPath).val(channelType);
  toggleFormChannelType(channelType);
  $(channelFormEmailSubjectCssPath).val(channel.subject || '');
  $(channelFormEmailBodyCssPath).val(channel.body || '');
  $(channelFormSMSMessageCssPath).val(channel.message || '');
}

export function getData() {
  const id = $(channelFormIdCssPath).val();
  const name = $(channelFormNameCssPath).val();
  const type = $(channelFormTypeCssPath).val();

  if (type === 'email') {
    const subject = $(channelFormEmailSubjectCssPath).val();
    const body = $(channelFormEmailBodyCssPath).val();
    return { id, name, type: 'email', subject, body };
  }
  if (type === 'sms') {
    const message = $(channelFormSMSMessageCssPath).val();
    return { id, name, type: 'sms', message };
  }
  throw new Error(`Invalid channel type ${type}`);
}

export function onSubmit(cb) {
  $(document).on('click', channelFormSaveBtnCssPath, function () {
    cb({ mode: $(this).closest(channelFormCssPath).attr('data-mode'), data: getData() });
  });
}

export function onCancel(cb) {
  $(document).on('click', channelFormCancelBtnCssPath, function () {
    cb({ mode: $(this).closest(channelFormCssPath).attr('data-mode'), data: getData() });
  });
}
